// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__y9v_7","right":"styles_right__2NDxJ"};